import asbp4Pdf from "../assets/files/asbp4.pdf";

/**
 * ПБАМ-1…ПБАМ-4.
 *
 * Раньше это были четыре почти идентичных файла страниц (~660 строк на всех),
 * отличавшихся только набором ключей перевода. Теперь это данные, а рендерит их
 * один компонент `PbamProgramPage`.
 */
export const PBAM_PROGRAMS = [
  {
    slug: "pbam1",
    path: "pbam1",
    titleKey: "pbam1_title",
    sectionKeys: [
      "pbam1_intro",
      "pbam1_history",
      "pbam1_goals",
      "pbam1_stages",
      "pbam1_funding",
      "pbam1_results",
    ],
    documents: [],
  },
  {
    slug: "pbam2",
    path: "pbam2",
    titleKey: "pbam2_title",
    sectionKeys: [
      "pbam2_intro",
      "pbam2_structure",
      "pbam2_development",
      "pbam2_projects",
      "pbam2_funding",
      "pbam2_contribution",
    ],
    documents: [],
  },
  {
    slug: "pbam3",
    path: "pbam3",
    titleKey: "pbam3_title",
    sectionKeys: [
      "pbam3_intro",
      "pbam3_development",
      "pbam3_structure",
      "pbam3_projects",
      "pbam3_results",
    ],
    documents: [],
  },
  {
    slug: "pbam4",
    path: "pbam4",
    titleKey: "pbam4_title",
    sectionKeys: [
      "pbam4_intro",
      "pbam4_development",
      "pbam4_structure",
      "pbam4_goals",
      "pbam4_projects",
      "pbam4_process",
    ],
    documents: [{ id: "asbp4", labelKey: "pbam4_title", href: asbp4Pdf }],
  },
];

export const PBAM_BY_SLUG = Object.fromEntries(
  PBAM_PROGRAMS.map((program) => [program.slug, program]),
);

/** Программы, которые показываем в разделе «Публикации» и в подменю. */
export const PBAM_MENU_ITEMS = PBAM_PROGRAMS.map(
  ({ slug, path, titleKey }) => ({
    slug,
    path,
    titleKey,
  }),
);

export default PBAM_PROGRAMS;
